import React from 'react'
import TechnologyBannerComponent from './TechnologyBannerComponent'
import DTN from "../../assets/images/app/dtn-app.svg";
import Apischain from "../../assets/images/app/apischain.svg";
import AgriMiner from "../../assets/images/app/agriminer-app.svg";
import Marketplaces from "../../assets/images/app/shopping-store.svg";

import "./TechnologyComponent.css";
const TechnologyBanner = () => {

    const bannerData = [
        {
            href: "#DTNApp",
            image: DTN,
            title: "DTN App",
          },
          {
            href: "#ACNNetwork",
            image: Apischain,
            title: "ACN Network",
          },
     
          {
            href: "#AgriMinerApp",
            image: AgriMiner,
            title: "AgriMiner App",
          },
          {
            href: "#Marketplaces",
            image: Marketplaces,
            title: "Marketplaces",
          },
    ]
  return (
    <div className='pt-5 pb-5 technology-banner-section'>
        <TechnologyBannerComponent data = {bannerData}/>

    </div>
  )
}

export default TechnologyBanner